<template>
  <div>
    disconnected. redirected in 5 seconds.
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('logout');
    setTimeout(() => this.$router.push('/'), 5000);
  },
};
</script>
